import { type TFunction } from "i18next";

import type { WorkspaceDetailed } from "./api";

export function displayWorkspaceName(entry: WorkspaceDetailed, t: TFunction): string {
    if (entry.workspace.isPersonal) {
        return t("workspace:personalLabel");
    }
    return entry.workspace.name;
}
